import { Component, OnInit, AfterViewInit, OnDestroy, ElementRef, ViewChild, ChangeDetectorRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StripeService } from '../_servizi/stripe.service';
import { NgForm } from '@angular/forms';
import { StepService } from '../_servizi/step.service';
import { Router } from '@angular/router';
import { InitPagamento } from '../_classi/InitPagamento';
import { AnagraficaF } from '../_classi/AnagraficaF';
import { AnagraficaR } from '../_classi/AnagraficaR';
import { AnagraficaSP } from '../_classi/AnagraficaSP';
import { PagamentiService } from '../_servizi/pagamenti.service';
import { InitPagamentoStripe } from '../_classi/InitPagamentoStripe';
import { StripeMetadata } from '../_classi/StripeMetadata';
import { TranslateService } from '@ngx-translate/core';
import { ClientiService } from '../_servizi/clienti.service';

@Component({
  selector: 'app-stripe',
  templateUrl: './stripe.component.html',
  styleUrls: ['./stripe.component.css']
})
export class StripeComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  stripe: any;
  card: any;
  cardHandler = this.onChange.bind(this);
  error: string;

  datiUtente: any;
  datiPagamento: any;

  initPagamentoStripeValori: any;

  @ViewChild('cardInfo') cardInfo: ElementRef;
  @ViewChild('titolare') titolare: ElementRef;
  @ViewChild('telefono') telefono: ElementRef;
  @ViewChild('email') email: ElementRef;

  @Input() locale: string;
  @Input() totale: number;
  @Input() valori: any;
  @Input() usaStripeCantina: boolean;

  constructor(
    private stripeService: StripeService,
    private stepService: StepService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private pagamentiService: PagamentiService,
    private translate: TranslateService,
    private clientiService: ClientiService
  ) {

  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.card.removeEventListener('change', this.cardHandler);
    this.card.destroy();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.valori) {
      this.setTitolare(this.valori.utente.nome + ' ' + this.valori.utente.cognome);
      this.setEmail(this.valori.utente.email);
      this.setTelefono(this.valori.utente.telefono);
    }
  }

  ngAfterViewInit(): void {

    this.stripeService.getStripe().subscribe(value => {
      this.stripe = value;


      const elements = this.stripe.elements({
        locale: this.locale ? this.locale : 'auto',
        fonts: [
          {
            cssSrc: 'https://fonts.googleapis.com/css?family=Roboto',
          }
        ],
      });

      this.card = elements.create('card', {
        hidePostalCode: true,
        iconStyle: 'solid',
        style: {
          base: {
            iconColor: '#000',
            color: '#000',
            fontWeight: 400,
            fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
            fontSize: '16px',
            fontSmoothing: 'antialiased',

            '::placeholder': {
              color: '#858585'
            },
            ':-webkit-autofill': {
              color: '#786d38'
            }
          },
          invalid: {
            iconColor: '#ff789e',
            color: '#ff789e'
          }
        }
      });

      this.card.mount(this.cardInfo.nativeElement);

      this.card.addEventListener('change', this.cardHandler);
    });

  }

  completa() {

    let isStripeCantina = false;
    const infoStripe = this.stripeService.getInfoStripe();
    if (infoStripe && infoStripe['abilitatoAccount'] && this.usaStripeCantina) {
      isStripeCantina = true;
    }

    const initPagamentoValori: InitPagamento = new InitPagamento(
      this.valori.default.tipoPagamento,
      false,
      true,
      isStripeCantina,
      this.valori.default.isCodiceFormMasterPresente,
      this.translate.currentLang,
      this.valori.utente.id,
      this.valori.fiscali.tipoDocFormControl === 'F' ? 1 : 0,
      this.valori.default.noteordine,
      new AnagraficaF(
        this.valori.fiscali.denominazione_f,
        this.valori.fiscali.indirizzo_f,
        this.valori.fiscali.cap_f,
        this.valori.fiscali.citta_f,
        this.valori.fiscali.provincia_f,
        this.valori.fiscali.cf_f,
        this.valori.fiscali.fe_f
      ),
      new AnagraficaR(
        this.valori.fiscali.nome_r,
        this.valori.fiscali.cognome_r,
        this.valori.fiscali.indirizzo_r,
        this.valori.fiscali.cap_r,
        this.valori.fiscali.citta_r,
        this.valori.fiscali.provincia_r,
        this.valori.fiscali.cf_r
      ),
      new AnagraficaSP(
        this.valori.spedizione.denominazione_sp,
        this.valori.spedizione.indirizzo_sp,
        this.valori.spedizione.cap_sp,
        this.valori.spedizione.citta_sp,
        this.valori.spedizione.provincia_sp,
        this.valori.spedizione.telefono_sp,
        this.valori.spedizione.house_number_sp
      ),
      0,
      0,
      null,
      this.valori.listaCodiciScontoCarrello
    );



    this.pagamentiService.initPagamento(initPagamentoValori).subscribe(result => {
      if (result.risultato) {

        this.initPagamentoStripeValori = new InitPagamentoStripe(
          result.totaledapagare,
          new StripeMetadata(
            result.shopID,
            result.info2,
            result.info1,
            "",
            result.info3,
            this.valori.utente.id,
            this.valori.utente.cognome + " " + this.valori.utente.nome,
            this.valori.utente.email,
            this.valori.utente.telefono,
            this.translate.currentLang,
            this.valori.default.noteordine,
            0,
            0
          )
        )

        this.datiPagamento = {
          datiPagamento: this.initPagamentoStripeValori
        }
      }
    });
  }

  onChange({ error }) {
    if (error) {
      this.error = error.message;
    } else {
      this.error = null;
    }
    this.cd.detectChanges();
  }

  async onSubmit(form: NgForm) {

    this.clientiService.inserisciClienteNF(this.valori.utente).subscribe(result => {
      if (result['risultato']) {
        this.valori.utente.id = result['idCliente'];
      }

      let isStripeCantina = false;
      const infoStripe = this.stripeService.getInfoStripe();
      if (infoStripe && infoStripe['abilitatoAccount'] && this.usaStripeCantina) {
        isStripeCantina = true;
      }

      const initPagamentoValori: InitPagamento = new InitPagamento(
        this.valori.default.tipoPagamento,
        false,
        true,
        isStripeCantina,
        this.valori.default.isCodiceFormMasterPresente,
        this.translate.currentLang,
        this.valori.utente.id,
        this.valori.fiscali.tipoDocFormControl === 'F' ? 1 : 0,
        this.valori.default.noteordine,
        new AnagraficaF(
          this.valori.fiscali.denominazione_f,
          this.valori.fiscali.indirizzo_f,
          this.valori.fiscali.cap_f,
          this.valori.fiscali.citta_f,
          this.valori.fiscali.provincia_f,
          this.valori.fiscali.cf_f,
          this.valori.fiscali.fe_f
        ),
        new AnagraficaR(
          this.valori.fiscali.nome_r,
          this.valori.fiscali.cognome_r,
          this.valori.fiscali.indirizzo_r,
          this.valori.fiscali.cap_r,
          this.valori.fiscali.citta_r,
          this.valori.fiscali.provincia_r,
          this.valori.fiscali.cf_r
        ),
        new AnagraficaSP(
          this.valori.spedizione.denominazione_sp,
          this.valori.spedizione.indirizzo_sp,
          this.valori.spedizione.cap_sp,
          this.valori.spedizione.citta_sp,
          this.valori.spedizione.provincia_sp,
          this.valori.spedizione.telefono_sp,
          this.valori.spedizione.house_number_sp
        ),
        0,
        0,
        null,
        this.valori.listaCodiciScontoCarrello
      );



      this.pagamentiService.initPagamento(initPagamentoValori).subscribe(result => {
        if (result.risultato) {

          this.initPagamentoStripeValori = new InitPagamentoStripe(
            result.totaledapagare,
            new StripeMetadata(
              result.shopID,
              result.info2,
              result.info1,
              "",
              result.info3,
              this.valori.utente.id,
              this.valori.utente.cognome + " " + this.valori.utente.nome,
              this.valori.utente.email,
              this.valori.utente.telefono,
              this.translate.currentLang,
              this.valori.default.noteordine,
              0,
              0
            )
          )

          this.datiPagamento = {
            datiPagamento: this.initPagamentoStripeValori
          }

          this.stripeService.charge(this.datiPagamento)
            .subscribe(response => {
              this.stripe.confirmCardPayment(response.client_secret, {
                payment_method: {
                  card: this.card
                }
              }).then(result => {
                let stato = "";
                if (result.error) {
                  stato = 'ko';
                } else {
                  stato = 'ok';
                }
                this.router.navigateByUrl('step3/' + stato);
              });
            });
        }
      });
    });
  }


  setTitolare(titolare: string) {
    this.titolare.nativeElement.value = titolare;
  }
  setTelefono(telefono) {
    this.telefono.nativeElement.value = telefono;
  }
  setEmail(email: string) {
    this.email.nativeElement.value = email;
  }

  setDatiUtente(datiUtente) {
    this.datiUtente = datiUtente;
  }
  setDatiPagamento(datiPagamento) {
    this.datiPagamento = datiPagamento;
  }
}
